module.exports = __webpack_public_path__ + "img/hearts.95b56fc3.svg";